const IconCheck = (props = {}) => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5.98162 9.40148L12.0031 0.474234C12.312 0.0163688 12.9335 -0.104445 13.3914 0.204389C13.8492 0.513223 13.97 1.13475 13.6612 1.59262L6.95088 11.5411C6.64205 11.9989 6.02052 12.1197 5.56265 11.8109C5.50201 11.77 5.44727 11.7236 5.39866 11.6728C5.3799 11.6561 5.36162 11.6386 5.34387 11.6202L0.481261 6.58481C0.0976116 6.18753 0.108662 5.55446 0.505942 5.17081C0.903223 4.78716 1.53629 4.79821 1.91994 5.19549L5.98162 9.40148Z" />
    </svg>
  );
};

export default IconCheck;
